import Bugsnag from "@bugsnag/js";
import { getFeatureFlagValue } from "@nju/feature-flags";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { IGeneratePasswordResult } from "./types";
import { serverResponse } from "./validators";

export async function generatePassword(
  productId: string,
): Promise<IGeneratePasswordResult> {
  const isGeneratePasswordMockEnabled =
    getFeatureFlagValue("generateModemPasswordMock") === "1";
  const isNonProdEnv =
    process.env.NEXT_PUBLIC_APP_ENV === "int" ||
    process.env.NEXT_PUBLIC_APP_ENV === "dev";
  const shouldUseMockHeader = isGeneratePasswordMockEnabled && isNonProdEnv;

  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/products/${productId}/changePassword`,
    {
      method: "post",
      validator: serverResponse,
      headers: {
        ...(shouldUseMockHeader && {
          "x-mock": "noss-mock",
        }),
        "Accept-Language": "pl",
        "Client-Id": process.env.NEXT_PUBLIC_CLIENT_ID || "unknown",
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok({
    password: result.value.password,
  });
}
